<template>
    <div class="input-file-drag-drop vs-row w-full">
        <div class="vs-col w-full mb-4">
            <label class="vs-input--label">{{ label }}</label>
        </div>
        <div class="vs-col w-full drop-container"
             @dragover="dragover"
             @dragleave="dragleave"
             @drop="drop"
        >
            <input type="file"
                   name="fields[assetsFieldHandle][]"
                   :id="`${reference}-assetsFieldHandle`"
                   class="w-px h-px opacity-0 overflow-hidden absolute"
                   @change="select"
                   ref="file"
                   :accept="acceptedFiles"/>
            <label :for="`${reference}-assetsFieldHandle`" class="block cursor-pointer">
                <font-awesome-icon class="upload-icon" :icon="['far', 'cloud-upload-alt']"/>
                <div class="text">
                    {{ $t('UploadMultiUploadText') }}
                </div>
            </label>
        </div>

        <vs-row v-if="showFileList" v-cloak class="mt-6 text-left">
            <vs-col class="w-full additional-files-row" v-if="files.length">
                <div class="additional-file" v-for="(file, i) in files" :key="i">
                    <font-awesome-icon size="lg" class="file-icon" :icon="['fal', 'file']"/>
                    <span class="file">{{ file.name }}</span>
                    <a role="button" class="button cursor-pointer" @click="remove(files.indexOf(file))">
                       <font-awesome-icon size="lg" class="remove-icon" :icon="['fal', 'times']"/>
                    </a>
                </div>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
  export default {
    name: "InputFileDragDrop",
    props: {
      value: {},
      reference: {
        default: 'file',
        type: String,
      },
      label: {
        type: String,
      },
      fileListLabel: {
        type: String,
      },
      showFileList: {
        type: Boolean,
        default: true,
      },
      maxFiles: {
        type: Number,
        default: null
      },
      acceptedFiles: {
        type: String,
        default: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,application/vnd.ms-excel.sheet.macroEnabled.12,application/pdf',
      },
    },
    data() {
      return {
        files: [],
        input: null
     }
    },
    computed: {
      filename() {
        if (!this.file) {
          return '';
        }

        return this.file.name;
      }
    },
    mounted() {
      this.input = this.$el.querySelector('input[type=file]');
    },
    watch: {
      files (val) {
        this.$emit('input', val);
      }
    },
    methods: {
      checkMaxFiles(files) {
        const filesBeingDropped = files.length;
        const existingFiles = this.files.length;
        const totalFiles = filesBeingDropped + existingFiles;

        if (this.maxFiles && totalFiles > this.maxFiles) {
          let errorMessage = this.$t('MaximumFilesAllowedError');

          this.$vs.notify({
            title: this.$t('Error'),
            text: errorMessage.replace('MAX_NUMBER', this.maxFiles), 
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            position: "top-right"
          })

          return false;
        }

        return true;
      },
      checkMimeTypes(files) {
        const acceptedFiles = this.acceptedFiles.split(',');
        let validFile = true;

        const acceptedExcelMimeTypes = [
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/vnd.ms-excel',
          'application/vnd.ms-excel.sheet.macroEnabled.12',
        ];

        // const acceptedPdfMimeTypes = [
        //   'application/pdf',
        // ];

        // let haveExcelFile = false;
        // let havePdfFile = false;

        // // We will only accept 1 pdf and/or 1 excel. Never 2 of each.
        // this.files.forEach((uploadedFile) => {
        //   if (acceptedExcelMimeTypes.includes(uploadedFile.type)
        //       || uploadedFile.name.includes('.xlsm')
        //   ) {
        //     haveExcelFile = true;
        //   }

        //   if (acceptedPdfMimeTypes.includes(uploadedFile.type)) {
        //     havePdfFile = true;
        //   }
        // });

        // if (haveExcelFile && havePdfFile) {
        //   this.$vs.notify({
        //     title: 'Error',
        //     text: `Both files already uploaded`,
        //     iconPack: 'feather',
        //     icon: 'icon-alert-circle',
        //     color: 'danger',
        //     position: "top-right"
        //   })

        //   return false;
        // }

        files.forEach(file => {
          const isXlsm = file.name.includes('.xlsm')

          if (!acceptedFiles.includes(file.type)
              && !isXlsm
          ) {
            this.$vs.notify({
              title: 'Error',
              text: `Invalid file type`,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              position: "top-right"
            })

            validFile = false;
          }

          // if (haveExcelFile
          //     && (acceptedExcelMimeTypes.includes(file.type) || isXlsm)
          // ) {
          //   this.$vs.notify({
          //     title: 'Error',
          //     text: `File of the same type already uploaded`,
          //     iconPack: 'feather',
          //     icon: 'icon-alert-circle',
          //     color: 'danger',
          //     position: "top-right"
          //   })

          //   validFile = false;
          //   return;
          // }

          // if (havePdfFile
          //     && acceptedPdfMimeTypes.includes(file.type)
          // ) {
          //   this.$vs.notify({
          //     title: 'Error',
          //     text: `PDF already uploaded`,
          //     iconPack: 'feather',
          //     icon: 'icon-alert-circle',
          //     color: 'danger',
          //     position: "top-right"
          //   })

          //   validFile = false;
          // }
        })

        return validFile;
      },
      remove(i) {
        this.files.splice(i, 1);
      },
      dragover(event) {
        event.preventDefault();
        // Add some visual fluff to show the user can drop its files
        if (!event.currentTarget.classList.contains('bg-green-300')) {
          event.currentTarget.classList.remove('bg-gray-100');
          event.currentTarget.classList.add('bg-green-300');
        }
      },
      dragleave(event) {
        // Clean up
        event.currentTarget.classList.add('bg-gray-100');
        event.currentTarget.classList.remove('bg-green-300');
      },
      drop(event) {
        event.preventDefault();
        this.validateFiles(event.dataTransfer.files);
      },
      select() {
        this.validateFiles(this.$refs.file.files);
      },
      validateFiles(files) {
        if (!this.checkMaxFiles(files)
            || !this.checkMimeTypes(files)
        ) {
          return false;
        }

        this.addFiles(files);

        // Clean up
        event.currentTarget.classList.add('bg-gray-100');
        event.currentTarget.classList.remove('bg-green-300');
      },
      addFiles(files) {
        this.files.push(...files);
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../assets/scss/custom/components/variables';

    [v-cloak] {
        display: none;
    }

    .input-file-drag-drop {
      .vs-input--label {
        font-size: 15px;
        padding: 0;
        color: #262626;
      }

      .drop-container {
        border-radius: 5px;
        height: 148px;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        border: 1px solid $grey-light !important;
        background-color: $grey-lightest;

        .upload-icon {
          font-size: 2.4em;
          margin-bottom: 7px;
        }

        .text {
          font-size: 15px;
          color: #444B57;
        }
      }

      .additional-files-row {
        .additional-file {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin: .5rem 0;
          border: 1px solid $grey-light !important;
          border-radius: 5px;
          padding: 17px;
          box-shadow: 0 2px 7px 0 rgba(0,0,0,0.07);

          .file-icon {
            margin-right: 13px;
          }

          .file {
            font-size: 15px;
            color: #444B57;
          }

          .button {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: auto;
            border: 1px solid $grey-light;
            border-radius: 50%;
            text-align: center;
            height: 27.5px;
            width: 27.5px;

            &:hover {
              background-color: $grey-light;
            }
          }
        }
      }
    }
</style>
